<template>
  <div class="loginPwd">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 重置手机号码
    </div>
    <div class="title">
      <span>重置手机号码</span>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>

    <el-form :model="form" :rules="rules" ref="form" class="rule_form">
      <el-form-item label="社会信用代码：" prop="LoginName" label-width="150px">
        <el-input v-model="form.LoginName" placeholder="请输入社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="Contact" label-width="150px">
        <el-input v-model="form.Contact" placeholder="请输入联系人名称"></el-input>
      </el-form-item>
      <el-form-item label="设置新电子邮箱：" prop="Email" label-width="150px">
        <el-input v-model="form.Email" placeholder="请输入电子邮箱："></el-input>
      </el-form-item>
      <el-form-item label="设置新手机号：" prop="Mobile" label-width="150px">
        <el-input v-model="form.Mobile" placeholder="请输入手机号码后，获取验证码"></el-input>
        <div class="msg_code" @mousedown.stop="getCode()" :class="{ disabled }">{{ codeName }}</div>
      </el-form-item>
      <el-form-item label="短信验证码：" prop="AuthCode" label-width="150px">
        <el-input v-model="form.AuthCode" placeholder="请输入手机验证码"></el-input>
      </el-form-item>
      <el-form-item label="说明函：" prop="fileList" label-width="150px">
        <div class="file_wrap">
          <el-upload
            :action="uploadUrl"
            :before-remove="removeConfirm"
            :on-remove="handleRemove"
            :on-change="fileChange"
            :on-exceed="exceedFile"
            :on-success="handleSuccess"
            :on-error="handleError"
            :auto-upload="true"
            :file-list="fileList"
            :data="{}"
            :http-request="uploadTechnicalFile"
            ref="uploader"
          >
            <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">Tip：请上传相关说明函并加盖公章</div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn_1" @click="submit()">提交</div>
  </div>
</template>

<script>
import { validateEmail, validatemobile } from '@/assets/js/util'
export default {
  inject: ['reload'],
  data() {
    var validateContractFile = (rule, value, callback) => {
      if (this.fileList.length == 0) {
        callback(new Error('请上传说明函'))
      } else {
        callback()
      }
    }
    return {
      uploadUrl: '',
      validateMobile: '',
      height: document.body.clientHeight - 120 + 'px',
      codeName: '短信获取验证码',
      disabled: false,
      form: {
        LoginName: '',
        Contact: '',
        Email: '',
        Mobile: '',
        AuthCode: ''
      },
      rules: {
        Contact: [{ required: true, message: '请输入联系人名称', trigger: 'blur' }],
        AuthCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        Mobile: [{ required: true, message: '', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        fileList: [{ required: true, validator: validateContractFile, trigger: 'blur' }]
      },
      fileList: []
    }
  },
  computed: {
    Mobile() {
      return this.form.Mobile
    },
    LoginName() {
      return this.form.LoginName
    }
  },
  watch: {
    Mobile(newVal, oldVal) {
      if (newVal == this.validateMobile) {
        delete this.rules.Mobile[0].validator
      } else {
        this.rules.Mobile[0].validator = validatemobile
      }
      if (newVal != oldVal && oldVal != null) {
        this.form.AuthCode = ''
        clearInterval(this.timer)
        this.codeName = '短信获取验证码'
        this.disabled = false
      }
    },
    LoginName(newVal, oldVal) {
      if (newVal != oldVal && oldVal != null) {
        this.form.AuthCode = ''
        clearInterval(this.timer)
        this.codeName = '短信获取验证码'
        this.disabled = false
      }
    }
  },
  mounted() {},
  methods: {
    back() {
      this.$router.push('/')
    },
    Mobilechange() {
      console.log('1212')
      this.form.AuthCode = ''
    },

    getCode() {
      if (!this.form.LoginName) {
        this.$message.error('请输入公司社会信用代码')
        return
      }
      if (!this.form.Mobile) {
        this.$message.error('请输入手机号码')
        return
      }
      if (!this.disabled) {
        this.$refs['form'].validateField('Mobile', (valid) => {
          if (!valid) {
            this.postRequest('SupplierLogin/SendValidateCode4ResetMobile', {
              mobile: this.form.Mobile,
              loginName: this.form.LoginName
            }).then((res) => {
              if (res.data.errcode == 0) {
                localStorage.setItem('loginToken1', res.data.loginToken)
                let time = 60
                let timer = setInterval(() => {
                  this.disabled = true
                  if (time == 0) {
                    this.codeName = '短信获取验证码'
                    clearInterval(timer)
                    this.disabled = false
                  } else {
                    this.codeName = '重新发送(' + time + ')'
                    time--
                  }
                }, 1000)
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
          }
        })
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let stoken = window.localStorage.getItem('loginToken1')
          localStorage.setItem('loginToken', stoken)
          this.postRequest('SupplierLogin/SaveResetMobile', {
            dataJson: JSON.stringify(this.form),
            fileId: this.fileList
              .map((item) => {
                return item.fileId
              })
              .join(',')
          })
            .then((res) => {
              if (res.data.errmsg == 'OK') {
                this.$message({ type: 'success', message: '提交成功！' })
                window.localStorage.removeItem('loginToken')
                window.localStorage.removeItem('loginToken1')
                this.$router.push('/')
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
    },
    reflash() {
      this.reload()
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传100个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId2', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.fileList = this.fileList.filter((item) => {
              return item.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    uploadTechnicalFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = ''
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile2', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          let obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName
          }
          this.fileList.push(obj)
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loginPwd {
  margin-bottom: 100px;
  .title {
    position: relative;
    padding-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #0774c5;
    span {
      padding: 6px 40px;
      font-weight: bold;
      font-size: 16px;
      color: #0774c5;
      text-align: center;
      border-bottom: 2px solid #0774c5;
    }
    .back_btn {
      bottom: 6px;
    }
  }
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 25px;
    width: 160px;
  }
  .disabled {
    background: #ccc;
  }
}
.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
